import {
  createPartnerTrackingFailure,
  createPartnerTrackingRequest,
  createPartnerTrackingSuccess,
  getPartnerTrackingFailure,
  getPartnerTrackingRequest,
  getPartnerTrackingSuccess,
  removePartnerTrackingsFailure,
  removePartnerTrackingsRequest,
  removePartnerTrackingsSuccess,
} from "./partnerTrackingSlice";
import { call, put, select, takeLatest } from "redux-saga/effects";
import {
  createPartnerTracking,
  getPartnerTracking,
  removePartnerTracking,
} from "./partnerTrackingApi";
import { handleErrorSaga } from "../../utils/helper";

export function* handleGetPartnerTracking({ payload }) {
  try {
    const res = yield call(getPartnerTracking, payload);
    yield put(getPartnerTrackingSuccess(res.data));
  } catch (error) {
    yield put(getPartnerTrackingFailure());
    yield handleErrorSaga(error);
  }
}

function* handleCreatePartnerTracking({ payload }) {
  try {
    const res = yield call(createPartnerTracking, payload);
    yield put(createPartnerTrackingSuccess(res.data));
  } catch (error) {
    yield put(createPartnerTrackingFailure());
    yield handleErrorSaga(error);
  }
}

function* handleRemovePartnerTrackings({ payload }) {
  try {
    yield call(removePartnerTracking, payload._id);

    const temp = yield select(
      (state) => state.partnerTrackingState.listPartnerTracking
    );
    let data = [...temp];
    const index = data.findIndex((item) => item._id === payload._id);
    index >= 0 && data.splice(index, 1);

    yield put(removePartnerTrackingsSuccess([...data]));
  } catch (error) {
    yield put(removePartnerTrackingsFailure());
    yield handleErrorSaga(error);
  }
}

export default function* partnerTrackingSaga() {
  yield takeLatest(getPartnerTrackingRequest.type, handleGetPartnerTracking);
  yield takeLatest(
    createPartnerTrackingRequest.type,
    handleCreatePartnerTracking
  );
  yield takeLatest(
    removePartnerTrackingsRequest.type,
    handleRemovePartnerTrackings
  );
}
